import React from 'react';
import DattoEDRLogoWhite from 'common/icons/DattoEDRLogoWhite';
import WaveBackground from './WaveBackground';

const EmptyTopNav = () => (
    <div className="c-topnav p-hide">
        <div className="c-topnav-wave">
            <WaveBackground />
        </div>
        <div className="c-topnav__left">
            <a href={'https://infocyte.com/'} className="c-topnav__logo">
                <DattoEDRLogoWhite className={'c-topnav__logo-icon__datto-edr'} />
            </a>
        </div>
    </div>
);

export default EmptyTopNav;
